import React from "react";
import { ProgressionBarChart } from "../highcharts";
import { useChartData } from "./helpers/useChartData";

export interface ComparisonChartData {
  quote?: number;
  year: number;
  eps?: number;
  totalLiabilities?: number;
  operatingCashflow?: number;
  capEx?: number;
  freeCashflow?: number;
  totalEquity?: number;
  netIncome?: number;
  netRevenue?: number;
  outstandingShares?: number;
  returnOnAssets?: number;
  returnOnEquity?: number;
  fScore?: number;
  priceToBook?: number;
  priceToCashflow?: number;
  priceToFreeCashflow?: number;
  priceToSales?: number;
  priceToEarnings?: number;
}

export interface ComparisonBaseChartProps {
  shortLabel1: string;
  shortLabel2?: string;
  dataKey1: string;
  dataKey2?: string;
  quoteLabel: string;
  data: ComparisonChartData[];
}

export const ComparisonBaseChart = ({
  data,
  shortLabel1,
  shortLabel2,
  quoteLabel,
  dataKey1,
  dataKey2,
}: ComparisonBaseChartProps) => {
  const newData = useChartData(
    data,
    dataKey1,
    shortLabel1,
    dataKey2,
    shortLabel2,
    quoteLabel
  );
  return <ProgressionBarChart chartData={newData} height={310} />;
};
